import type { Guide } from "@/types";
import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}


export const PATH_TO_GUIDES_WIDGET =
process.env.NODE_ENV === "development"
  ? "http://localhost:3011/g/shared/"
  : "https://folge.app/g/shared/";

export const getGuidePublicUrl = (guide: Guide) => {
  return `${PATH_TO_GUIDES_WIDGET}${guide.slug}/${guide.publicUrl}`;
}

export const getGuideWidgetUrl = (guide: Guide) => {
  return `${PATH_TO_GUIDES_WIDGET}${guide.slug}?widget=1`;
}

/**
 * Get the base URL for a help center based on environment
 * @param slug - The help center slug
 * @returns The base URL for the help center
 */
export const getHelpCenterBaseUrl = (slug: string): string => {
  const IS_DEV = process.env.NODE_ENV === 'development';
  return IS_DEV 
    ? `http://${slug}.folge.test:3011`
    : `https://${slug}.folge.app`;
};

/**
 * Get the full URL for a help center with optional path
 * @param slug - The help center slug
 * @param path - Optional path to append (defaults to '/')
 * @returns The full URL for the help center
 */
export const getHelpCenterUrl = (slug: string, path: string = '/'): string => {
  const baseUrl = getHelpCenterBaseUrl(slug);
  // Ensure path starts with /
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${baseUrl}${normalizedPath}`;
};